document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-group-nav-bar-item a[href^="#"]').forEach((anchorLink) => {
    anchorLink.addEventListener('click', (event) => {
      const href = anchorLink.getAttribute('href');
      const targetId = href?.substring(1);
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      const rect = target.getBoundingClientRect();
      const scrollDirection = rect.top > 0 ? 'down' : 'up';

      window.scrollBy(0, scrollDirection === 'down' ? 20 : -20);

      setTimeout(() => {
        let scrollPaddingTop = 0;
        const scrollContainer = document.scrollingElement || document.documentElement;
        const computedStyle = window.getComputedStyle(scrollContainer);
        if (computedStyle.scrollPaddingTop) {
          scrollPaddingTop = parseInt(computedStyle.scrollPaddingTop, 10);
        }

        scrollPaddingTop += 150;

        const newRect = target.getBoundingClientRect();
        const targetY = window.scrollY + newRect.top - scrollPaddingTop;

        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }, 10);
    });
  });

  function toggleMenuItems(){
    setTimeout(() => { // We need to delay so other functions triggered by this event runs first
      document.querySelectorAll('.menu-group-nav-bar-item a[href^="#"]').forEach((anchor) => {
        const href = anchor.getAttribute('href');
        const targetId = href?.substring(1);
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        if (target.classList.contains('hidden!')) {
          anchor.closest('li').classList.add('hidden!');
        }else{
          anchor.closest('li').classList.remove('hidden!');
        }
      });
    }, 1);
  }

  toggleMenuItems();
  document.body.addEventListener('venueChanged', toggleMenuItems);
});
